export const QUINCE_GAYLORD_SORTATION_CENTERS = ["SC_EWR_1", "SC_ATL_1", "SC_TST_1"];
